import { render } from "./SessionInventories.vue?vue&type=template&id=85ff0cc8"
import script from "./SessionInventories.vue?vue&type=script&lang=js"
export * from "./SessionInventories.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__